export const BENEFITS_HEALTH = 'd3le1lc24f';
export const BENEFITS_PICKY = 'i7f8l9y94w';
export const REVIEWS_HERO = 'qxz0k46jak';
export const REVIEWS_BANNER = 'ao4qbtou21';
export const FOREVER_AD = 'z0dbb6aoyf';
export const MEET_THE_FOUNDERS = 'lyn2721eiy';
